import { render, staticRenderFns } from "./wechat_categories.vue?vue&type=template&id=58cf0ba4&"
import script from "./wechat_categories.vue?vue&type=script&lang=js&"
export * from "./wechat_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports